export default {
  data() {
    return {};
  },
  computed: {
    /**
     * ログイン状態を取得する
     * @returns {boolean} ログイン済みならtrue
     */
    isLoggedIn() {
      let loginState = this.$store.getters["loginInfo/getLoginState"];
      return loginState;
    }
  },
  methods: {
    async logout() {
      this.logoutThemiStruct();
      await this.logoutSoftbank();
      this.removeData();
      this.$router.push({ name: "CrlyTop" }).catch(() => {});
    },
    // ThemiStruct ログアウト
    logoutThemiStruct() {
      try {
        const sdk = new IPSDK("https", process.env.VUE_APP_LOGIN_API_FQDN, "443");
        this.$store.dispatch("loadingCrly/show", 10);
        sdk.signout("POST");
      } catch (e) {
        console.log(e);
      } finally {
        this.$store.dispatch("loadingCrly/hide", 10);
      }
    },
    // ソフトバンクログアウト処理
    async logoutSoftbank() {
      this.$store.dispatch("loadingCrly/show", 10);
      await this.$repositories("softbank")
        .getSoftBankLogout()
        .then((res) => {})
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.$store.dispatch("loadingCrly/hide", 10);
        });
    },
    removeData() {
      // 保持している情報を削除する
      this.$store.commit("loginInfo/removeAll");
      this.$store.commit("userInfo/removeAll");
    },
    /**
     * 検索画面への遷移用URLを作成
     * @param {Number} type 特大カテゴリ
     * @param {Array} params URLパラメータ
     * @returns {String} URL
     */
    makeSearchUrl(type, params) {
      let url = "";
      if (type === this.CONST.CATEGORY_TYPE.TRAVEL) {
        // 宿泊の場合
        url = process.env.VUE_APP_BASE_URL + "/search/menu?";
      } else if (type === "tour") {
        // 宿泊の場合
        url = process.env.VUE_APP_LIFE_DOMAIN + "/menus/tour?";
      } else if (type === this.CONST.CATEGORY_TYPE.LIFE || type === this.CONST.CATEGORY_TYPE.GOURMET) {
        url = process.env.VUE_APP_LIFE_DOMAIN + "/menus?";
      } else if (type === this.CONST.CATEGORY_TYPE.BENE){
        url = process.env.VUE_APP_SHOP_DOMAIN + "/menus?"
      }

      return url + params.join("&");
    },
    /**
     * 画面遷移を行う
     * @param {String} url 遷移先URL
     * @param {String} target 遷移先ターゲット(_self/_blank)
     */
    windowOpen(url, target = "_self") {
      window.open(url, target);
    },
    /**
     * 値のNullチェック
     * @param {Any} value チェックしたい値
     * @return {Boolean} 空ならtrue
     */
    isNullOrEmpty(value) {
      if (typeof value === "undefined") {
        return true;
      } else if (value === null) {
        return true;
      } else if (value === "") {
        return true;
      }
      return false;
    },
    /**
     * 数値かどうかのチェック
     * @param {Any} value チェックしたい値
     * @returns {Boolean} 数値ならtrue
     */
    isNumber(value) {
      return isFinite(value);
    },
    /**
     * メールの形式チェック
     * @param {String} value メールアドレス
     * @returns {Boolean} 正しい形式であればtrue
     */
    validateMail(value) {
      return value.match(
        /^([a-zA-Z0-9_\-\.\+])+@(([a-zA-Z0-9_\-])+\.)+[a-zA-Z]{2,6}$/
      );
    },
    /**
     * 全角カナのみかのチェック
     * @param {String} value チェックしたい文字列
     * @returns {Boolean} 全角カナのみのみであればtrue
     */
    isZenkakuKana(value) {
      return !!value.match(/^[ァ-ヶー　]*$/); // 「　」は全角スペースです.
    }
  }
};
